import React from 'react';
import { motion } from 'framer-motion';
export function Solution() {
  return <section id="solution" className="py-24 bg-stone-900 text-stone-50" data-id="element-1128">
      <div className="max-w-6xl mx-auto px-6" data-id="element-1129">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-1130">
          <p className="font-mono text-xs uppercase tracking-widest text-stone-400 mb-6" data-id="element-1131">
            The Solution
          </p>

          <h2 className="font-serif text-4xl md:text-5xl tracking-tight leading-[1.1] text-stone-50 mb-6 max-w-3xl" data-id="element-1132">
            From email chaos to instant infrastructure
          </h2>

          <p className="text-lg text-stone-400 leading-relaxed mb-16 max-w-2xl" data-id="element-1133">
            BlockQuote replaces the entire manual quoting workflow with
            real-time infrastructure. What took days now takes seconds.
          </p>

          {/* Workflow Diagram */}
          <div className="border border-stone-700" data-id="element-1134">
            {/* Header */}
            <div className="grid grid-cols-2 border-b border-stone-700" data-id="element-1135">
              <div className="p-4 border-r border-stone-700" data-id="element-1136">
                <p className="font-mono text-xs uppercase tracking-widest text-stone-500" data-id="element-1137">
                  Before: Manual Process
                </p>
              </div>
              <div className="p-4" data-id="element-1138">
                <p className="font-mono text-xs uppercase tracking-widest text-stone-500" data-id="element-1139">
                  After: BlockQuote
                </p>
              </div>
            </div>

            {/* Step 1 */}
            <div className="grid grid-cols-2 border-b border-stone-700" data-id="element-1140">
              <div className="p-6 border-r border-stone-700" data-id="element-1141">
                <div className="flex items-start gap-4" data-id="element-1142">
                  <span className="font-mono text-xs text-stone-500 mt-1" data-id="element-1143">
                    01
                  </span>
                  <div data-id="element-1144">
                    <p className="text-stone-300 font-medium mb-1" data-id="element-1145">
                      Email RFP received
                    </p>
                    <p className="text-sm text-stone-500" data-id="element-1146">
                      Unstructured data, manual parsing required
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-stone-800/50" data-id="element-1147">
                <div className="flex items-start gap-4" data-id="element-1148">
                  <span className="font-mono text-xs text-red-600 mt-1" data-id="element-1149">
                    01
                  </span>
                  <div data-id="element-1150">
                    <p className="text-stone-50 font-medium mb-1" data-id="element-1151">
                      Instant quote request
                    </p>
                    <p className="text-sm text-stone-400" data-id="element-1152">
                      Structured input, real-time pricing
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 2 */}
            <div className="grid grid-cols-2 border-b border-stone-700" data-id="element-1153">
              <div className="p-6 border-r border-stone-700" data-id="element-1154">
                <div className="flex items-start gap-4" data-id="element-1155">
                  <span className="font-mono text-xs text-stone-500 mt-1" data-id="element-1156">
                    02
                  </span>
                  <div data-id="element-1157">
                    <p className="text-stone-300 font-medium mb-1" data-id="element-1158">
                      Manual pricing lookup
                    </p>
                    <p className="text-sm text-stone-500" data-id="element-1159">
                      Check PMS, spreadsheets, rate cards
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-stone-800/50" data-id="element-1160">
                <div className="flex items-start gap-4" data-id="element-1161">
                  <span className="font-mono text-xs text-red-600 mt-1" data-id="element-1162">
                    02
                  </span>
                  <div data-id="element-1163">
                    <p className="text-stone-50 font-medium mb-1" data-id="element-1164">
                      Auto-generated packages
                    </p>
                    <p className="text-sm text-stone-400" data-id="element-1165">
                      Good / Better / Best within policy
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 3 */}
            <div className="grid grid-cols-2 border-b border-stone-700" data-id="element-1166">
              <div className="p-6 border-r border-stone-700" data-id="element-1167">
                <div className="flex items-start gap-4" data-id="element-1168">
                  <span className="font-mono text-xs text-stone-500 mt-1" data-id="element-1169">
                    03
                  </span>
                  <div data-id="element-1170">
                    <p className="text-stone-300 font-medium mb-1" data-id="element-1171">
                      48–72 hour response
                    </p>
                    <p className="text-sm text-stone-500" data-id="element-1172">
                      Back-and-forth negotiation via email
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-stone-800/50" data-id="element-1173">
                <div className="flex items-start gap-4" data-id="element-1174">
                  <span className="font-mono text-xs text-red-600 mt-1" data-id="element-1175">
                    03
                  </span>
                  <div data-id="element-1176">
                    <p className="text-stone-50 font-medium mb-1" data-id="element-1177">
                      Instant hold + proposal
                    </p>
                    <p className="text-sm text-stone-400" data-id="element-1178">
                      Inventory secured, terms standardized
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 4 */}
            <div className="grid grid-cols-2" data-id="element-1179">
              <div className="p-6 border-r border-stone-700" data-id="element-1180">
                <div className="flex items-start gap-4" data-id="element-1181">
                  <span className="font-mono text-xs text-stone-500 mt-1" data-id="element-1182">
                    04
                  </span>
                  <div data-id="element-1183">
                    <p className="text-stone-300 font-medium mb-1" data-id="element-1184">
                      Lost groups + leakage
                    </p>
                    <p className="text-sm text-stone-500" data-id="element-1185">
                      No audit trail, margin captured by wholesalers
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-stone-800/50" data-id="element-1186">
                <div className="flex items-start gap-4" data-id="element-1187">
                  <span className="font-mono text-xs text-red-600 mt-1" data-id="element-1188">
                    04
                  </span>
                  <div data-id="element-1189">
                    <p className="text-stone-50 font-medium mb-1" data-id="element-1190">
                      One-click contract
                    </p>
                    <p className="text-sm text-stone-400" data-id="element-1191">
                      Direct booking, full audit trail, zero leakage
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Summary row */}
            <div className="grid grid-cols-2 border-t border-stone-700" data-id="element-1192">
              <div className="p-6 border-r border-stone-700" data-id="element-1193">
                <p className="font-mono text-sm text-stone-500" data-id="element-1194">
                  Result:{' '}
                  <span className="text-stone-300" data-id="element-1195">
                    Days of delay, margin loss
                  </span>
                </p>
              </div>
              <div className="p-6 bg-stone-800/50" data-id="element-1196">
                <p className="font-mono text-sm text-stone-400" data-id="element-1197">
                  Result:{' '}
                  <span className="text-red-600" data-id="element-1198">
                    Seconds to quote, direct revenue
                  </span>
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}